module.exports = __webpack_public_path__ + "static/media/grip-lines.9580f0bb.svg";